import { render, staticRenderFns } from "./SubTipoSelect.vue?vue&type=template&id=bd2525ac&"
import script from "./SubTipoSelect.vue?vue&type=script&lang=js&"
export * from "./SubTipoSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports